import {
  anEntityInterface,
  anInsight,
  aSearchResult,
  aSearchResultPage,
  aSignal,
  mockAdvancedSearchQueryOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockAdvancedSearchQueryOperationQuery(
    async ({ query: _query, variables }) => {
      await delay(1500);
      const resultType = variables.resultType;

      const results =
        resultType === 'INSIGHTS'
          ? aSearchResultPage({
              objects: [
                aSearchResult({
                  object: anInsight(),
                }),
              ],
            })
          : resultType === 'SIGNALS'
            ? aSearchResultPage({
                objects: [
                  aSearchResult({
                    object: aSignal(),
                  }),
                ],
              })
            : resultType === 'ENTITIES'
              ? aSearchResultPage({
                  objects: [
                    aSearchResult({
                      object: anEntityInterface(),
                    }),
                  ],
                })
              : aSearchResultPage();

      return HttpResponse.json({
        data: {
          __typename: 'Query',
          dslSearchResults: results,
        },
      });
    }
  ),
];
